import { render, staticRenderFns } from "./ScreenshotsBlock.vue?vue&type=template&id=05e10ef6&scoped=true&"
import script from "./ScreenshotsBlock.vue?vue&type=script&lang=js&"
export * from "./ScreenshotsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e10ef6",
  null
  
)

export default component.exports